import { calculationColor } from '../../utils/colorUtils';
import StyleFactory from '../../StyleFactory';
export const themeSelector = (value, theme) => {
  if (value < theme.min) {
    // for values which are 'not weather' return water color
    return {
      color: theme.waterColor
    };
  }

  return {
    color: calculationColor(theme.color, value, theme.min, theme.max)
  };
};
export default {
  grid: StyleFactory.createDefaultGridStyle(themeSelector),
  line: StyleFactory.createDefaultIsolineStyle(themeSelector),
  area: StyleFactory.createDefaultAreaStyle(themeSelector)
};